function Footer({ content }: { content: string }) {
	return (
		<section id="footer" className="bg-primary-foreground">
			<p className="p-2 text-left text-xs font-light opacity-20">{content}</p>
		</section>
	)
}

export default Footer
